export interface RenewalDayThreshold {
  days?: number;
}

/**
 * Parses a `{Context}_Renewal_Notice_Thresholds` CMS label value and returns the largest `days`
 * entry. Used as the fallback for `*_Renewal_Coverage_Max_Days` settings so the coverage window
 * and the notice thresholds can't drift out of sync from a half-updated CMS edit. Returns 0 when
 * the value is missing, malformed, or carries no numeric `days` entries.
 */
export function getMaxThresholdDays(settingValue: string | null | undefined): number {
  if (!settingValue) {
    return 0;
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(settingValue);
  } catch {
    return 0;
  }
  if (!Array.isArray(parsed)) {
    return 0;
  }

  const days = parsed
    .filter((entry): entry is RenewalDayThreshold => !!entry && typeof entry === 'object' && typeof (entry as RenewalDayThreshold).days === 'number')
    .map((entry) => entry.days as number);

  return days.length > 0 ? Math.max(...days) : 0;
}
